import { isEmpty } from 'lodash'
import { useState } from 'react'

import { getThi } from '#/components/FormatCell/Types/thi'
import MapsAlerts from '#/components/Maps/components/Alerts'
import MapsNoLocation from '#/components/Maps/components/NoLocation'
import MapLegend from '#/components/Maps/Legend'
import MapMarkers from '#/components/Maps/Markers'
import { Markers } from '#/components/Maps/Markers/types'
import { splitMarkersByCoordinates } from '#/components/Maps/Utils/splitMarkersByCoordinates'

import { MapWrapper } from './Wrapper'

export interface MapsProps {
  id: string
  center: google.maps.LatLngLiteral
  zoom?: number
  mapTypeId?: 'satellite' | 'hybrid' | 'roadmap' | 'terrain'
  markers?: Markers
  height?: string | number
}

export function Maps({ center, height, id, mapTypeId = 'hybrid', markers, zoom }: MapsProps) {
  const { invalidMarkers, validMarkers } = splitMarkersByCoordinates(markers)

  if (!center?.lat || !center?.lng) {
    return <MapsNoLocation />
  }

  const [disabledLegends, setDisabledLegends] = useState<any[]>([])

  const handleChange = (legend: any) => {
    if (!legend.active) {
      return setDisabledLegends(prev => [...prev, legend])
    }
    return setDisabledLegends(prev => prev.filter(l => l.id !== legend.id))
  }

  const filterMarkers = () => {
    // para copiar o objeto e não usar a referência
    const result = { ...validMarkers }

    disabledLegends.forEach(legend => {
      const { id, type } = legend

      const markersType = result?.[type]

      if (!markersType) return

      if (result?.[type]) {
        result[type] = markersType.filter(m => {
          if (type === 'ccom') {
            return id !== m.status_for_map
          }

          if (type === 'cenv') {
            return id !== getThi(m.thi).status
          }

          if (type === 'farm') {
            return id !== 'farm'
          }

          return id !== m.id
        })
      }
    })

    return result
  }

  const filteredMarkers = filterMarkers()

  return (
    <>
      {!isEmpty(invalidMarkers) && <MapsAlerts markers={invalidMarkers} />}
      {/* Envolve o mapa com o MapWrapper, que configura e exibe o mapa */}
      <MapWrapper id={id} center={center} mapTypeId={mapTypeId} zoom={zoom} height={height}>
        {/* Renderiza os marcadores dentro do mapa, associados ao ID do mapa */}
        {!isEmpty(filteredMarkers) && <MapMarkers id={id} markers={filteredMarkers} />}
      </MapWrapper>
      <MapLegend markers={validMarkers} onChange={handleChange} />
    </>
  )
}
